import types from './types';
import {
    fetchElementsPaginated,
    fetchElement,
    submitElement,
    deleteElement
} from './common';
import {
    CALL_API
} from 'redux-api-middleware';

const apiUrl = '/api/stages';

export function submitStage(values) {
    return submitElement(apiUrl, values, types.SUBMIT_STAGE);
}

export function fetchStage(itemId) {
    return fetchElement(apiUrl, itemId, types.LOAD_STAGE);
}

export function loadStages(page = 0, size = 10, queryData = {}) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.LOAD_STAGES_PAGINATED, queryData);
}

export function fetchStageParticipants(itemId, page = 0, size = 20, queryData = {}) {
    return fetchElementsPaginated(`${apiUrl}/${itemId}/participants`, page, size, types.LOAD_STAGE_PARTICIPANTS, queryData);
}

export function fetchStageResults(itemId, page = 0, size = 20, queryData = {}) {
    return fetchElementsPaginated(`${apiUrl}/${itemId}/results`, page, size, types.LOAD_STAGE_RESULTS, queryData);
}


export function deleteStage(stage) {
    return deleteElement(apiUrl, stage.id, types.DELETE_STAGE);
}

export function submitStageResults(id, values) {
    const data = new FormData();
    data.append('file', values.file);
    data.append('col_count', values.col_count);
    return {
        [CALL_API]: {
            endpoint: `${apiUrl}/${id}/results`,
            method: 'POST',
            body: data,
            types: types.SAVE_STAGE_RESULTS.all
        }
    };
}

export function uploadParticipants(id, values) {
    const data = new FormData();
    data.append('file', values.file);
    return {
        [CALL_API]: {
            endpoint: `${apiUrl}/${id}/participant-upload`,
            method: 'POST',
            body: data,
            types: types.UPLOAD_STAGE_PARTICIPANTS.all
        }
    };
}


export function fetchAllStages(seasonId = null) {
    return {
        [CALL_API]: {
            endpoint: seasonId ? `${apiUrl}?season=${seasonId}` : apiUrl,
            method: 'GET',
            types: types.LOAD_STAGES.all
        }
    };
}

export function fetchUpcomingStage() {
    return {
        [CALL_API]: {
            endpoint: `${apiUrl}/upcoming`,
            method: 'GET',
            types: types.LOAD_UPCOMING_STAGE.all
        }
    };
}

export function fetchRegistratioToCustom() {
    return {
        [CALL_API]: {
            endpoint: `${apiUrl}/registration-to-custom`,
            method: 'GET',
            types: types.REGISTRATION_TO_CUSTOM.all
        }
    };
}

export function fetchRegistratioToAll() {
    return {
        [CALL_API]: {
            endpoint: `${apiUrl}/registration-to-all`,
            method: 'GET',
            types: types.REGISTRATION_TO_ALL.all
        }
    };
}

export function updateStageDistance(distance) {
    return {
        type: types.ADMIN_UPDATE_STAGE_DISTANCE,
        payload: {
            distance
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/actions/stages.js